import _ from 'lodash';

export const keyMap = {
  Agi: 'Agility',
  Str: 'Strength',
  Sta: 'Stamina',
  Int: 'Intellect',
  Spi: 'Spirit',

  Crit: 'CritRating',
  Haste: 'HasteRating',
  Mastery: 'MasteryRating',
  Vers: 'Versatility',

  Armor: 'Armor',
  BonusArmor: 'BonusArmor',
  Wdps: 'Dps',
  WOHdps: 'OffHandDps',
  SP: 'SpellPower',
  AP: 'Ap',

  // Leech
  // RunSpeed
  // Avoidance
};

export const formatPawnFromScaleFactors = (name, charClass, spec, factors, includeClassSpec) => {
  const scaleName = name || 'Simbot';
  const stats = _.map(
    _.pickBy(factors, (value, key) => keyMap[key] && value !== 0),
    (value, key) => `${keyMap[key]}=${_.round(value, 2).toFixed(2)}`,
  );
  if (includeClassSpec) {
    if (spec) {
      stats.unshift(`Spec=${_.upperFirst(_.camelCase(spec))}`);
    }
    if (charClass) {
      stats.unshift(`Class=${_.upperFirst(_.camelCase(charClass))}`);
    }
  }
  return `( Pawn: v1: "${scaleName}": ${stats.join(', ')} )`;
};

